module.exports = __webpack_public_path__ + "assets/media/Q1.f58b4a3c.mp4";